module.exports = __webpack_public_path__ + "static/img/bg2.d4f5df0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/bg2.png
// module id = 448
// module chunks = 1